<template>
	<div class="center_right">
		<div class="center_commNav">
			<div class="center_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
		</div>
		<div v-show="activeName=='1'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="课程名称：">
							<el-input v-model="finiOnname" placeholder="请输入课程名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="课程类型：">
							<el-select :popper-append-to-body='false' v-model="finiOntypeId" placeholder="请选择课程类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<br />
						<el-form-item label="作业名称：">
							<el-input v-model="finiOntaskName" placeholder="请输入作业名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="发布人：">
							<el-input v-model="finiOnuserName" placeholder="请输入发布人" clearable></el-input>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOnCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOnFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOnlistData" ref='centerfiniOnTable' border stripe>
					<emptymain slot='empty' :emptylist='finiOnlistData'></emptymain>
					<el-table-column type="expand">
						<template slot-scope="scope">
							<div class="center_tableAppend">
								<el-table :data="scope.row.userTask || []" border stripe>
									<emptymain slot='empty' :emptylist='scope.row.userTask || []'></emptymain>
									<el-table-column prop="name" label="作业名称" align="center">
									</el-table-column>
									<el-table-column prop="endTime" label="提交截止日期" align="center">
										<template slot-scope="scope">
											{{scope.row.endTime | spliceForTask}}
										</template>
									</el-table-column>
									<el-table-column prop="createUsername" label="发布人" align="center">
									</el-table-column>
									<el-table-column prop="isFinish" label="当前状态" align="center">
										<template slot-scope="scope">
											<div class="task_status infoColor"><img src="@/images/task_status2.png" />未提交</div>
										</template>
									</el-table-column>
									<el-table-column label="操作" width='150' align="center">
										<template slot-scope="scope">
											<el-button size="mini" type="warning" :disabled="getDisabld(scope.row)" @click="startTask(scope.row)">写作业</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="课程信息" width='450' align='center'>
						<template slot-scope="scope">
							<div class="center_courseBox pointer" @click="toCourseindex(scope.row)">
								<div class="center_courseinfo">
									<img :src="baseurl + scope.row.banner" />
								</div>
								<div class="center_courseTitle text-ellipsis">{{scope.row.courseName}}</div>
								<div class="center_courseDesc text-ellipsis"><i class="el-icon-s-order"></i>{{scope.row.courseTypeName || '-'}}</div>
								<div class="center_courseDesc text-ellipsis"><i class="el-icon-s-custom"></i>{{scope.row.teacherName}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="作业数量" prop="taskCount" align='center'>
						<template slot-scope="scope">
							<el-tag type='warning'>
								{{scope.row.taskCount || 0}}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click='finiOnAppend(scope.row)'>详情</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOnCurrentChange" :current-page="finiOncurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOntotal">
				</el-pagination>
			</div>
		</div>
		<div v-show="activeName=='2'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="课程名称：">
							<el-input v-model="finiOffname" placeholder="请输入课程名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="课程类型：">
							<el-select :popper-append-to-body='false' v-model="finiOfftypeId" placeholder="请选择课程类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<br />
						<el-form-item label="作业名称：">
							<el-input v-model="finiOfftaskName" placeholder="请输入作业名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="发布人：">
							<el-input v-model="finiOffuserName" placeholder="请输入发布人" clearable></el-input>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOffCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOffFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOfflistData" ref='centerfiniOffTable' border stripe>
					<emptymain slot='empty' :emptylist='finiOfflistData'></emptymain>
					<el-table-column type="expand">
						<template slot-scope="scope">
							<div class="center_tableAppend">
								<el-table :data="scope.row.userTask || []" border stripe>
									<emptymain slot='empty' :emptylist='scope.row.userTask || []'></emptymain>
									<el-table-column prop="name" label="作业名称" align="center">
									</el-table-column>
									<el-table-column prop="endTime" label="提交截止日期" align="center">
										<template slot-scope="scope">
											{{scope.row.endTime | spliceForTask}}
										</template>
									</el-table-column>
									<el-table-column prop="createUsername" label="发布人" align="center">
									</el-table-column>
									<el-table-column prop="isFinish" label="当前状态" align="center">
										<template slot-scope="scope">
											<div class="task_status successColor"><img src="@/images/task_status1.png" />已提交</div>
										</template>
									</el-table-column>
									<el-table-column label="操作" width='150' align="center">
										<template slot-scope="scope">
											<el-button size="mini" type="primary" @click="infoTask(scope.row)">查看</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="课程信息" width='450' align='center'>
						<template slot-scope="scope">
							<div class="center_courseBox pointer" @click="toCourseindex(scope.row)">
								<div class="center_courseinfo">
									<img :src="baseurl + scope.row.banner" />
								</div>
								<div class="center_courseTitle text-ellipsis">{{scope.row.courseName}}</div>
								<div class="center_courseDesc text-ellipsis"><i class="el-icon-s-order"></i>{{scope.row.courseTypeName || '-'}}</div>
								<div class="center_courseDesc text-ellipsis"><i class="el-icon-s-custom"></i>{{scope.row.teacherName}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="作业数量" prop="taskCount" align='center'>
						<template slot-scope="scope">
							<el-tag type='warning'>
								{{scope.row.taskCount || 0}}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click='finiOffAppend(scope.row)'>详情</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOffCurrentChange" :current-page="finiOffcurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOfftotal">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="课堂作业" class="open_dialogInfo" :visible.sync="taskOpenIndex" :append-to-body='true' width="1000px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<task-index v-if='taskOpenIndex' :taskId='taskId' @taskOver='taskOver'></task-index>
		</el-dialog>
		<el-dialog title="课堂作业详情" class="open_dialogInfo" :visible.sync="taskOpenInfo" :append-to-body='true' width="1000px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<task-info v-if='taskOpenInfo' :taskId='taskId'></task-info>
		</el-dialog>
	</div>
</template>

<script>
	import { getStorageToken } from '@/utils/auth'
	import { listMajorByPid } from '@/api/major'
	import { listUserTask, listUserTaskUn } from '@/api/task.js'
	import taskIndex from '@/views/courses/components/courseTaskIndex.vue'
	import taskInfo from '@/views/courses/components/courseTaskDetails.vue'
	export default {
		components: {
			taskIndex,
			taskInfo,
		},
		data() {
			return {
				activeName: '1',
				commNavs: [{
					name: '未提交作业',
					id: '1'
				}, {
					name: '已提交作业',
					id: '2'
				}],
				limit: 10,
				typeList: [],
				//已完成
				finiOntaskName: '',
				finiOnuserName: '',
				finiOnname: '',
				finiOntypeId: '',
				finiOnlistData: [],
				finiOncurrent: 1,
				finiOntotal: 0,
				//未完成
				finiOfftaskName: '',
				finiOffuserName: '',
				finiOffname: '',
				finiOfftypeId: '',
				finiOfflistData: [],
				finiOffcurrent: 1,
				finiOfftotal: 0,
				//open
				taskOpenInfo: false,
				taskOpenIndex: false,
				taskId: '',
			};
		},
		created() {
			this.getTypeList();
			this.getfiniOnListData();
			this.getfiniOffListData();
		},
		methods: {
			taskOver() {
				this.taskOpenIndex = false;
				this.taskId = '';
				this.clearfiniOnFilter();
				this.clearfiniOffFilter();
			},
			getDisabld(item) {
				if(item.beginTime && item.endTime) {
					var nowTime = new Date();
					var beginTime = new Date(item.beginTime);
					var endTime = new Date(item.endTime);
					if(nowTime > beginTime && nowTime < endTime) {
						return false
					} else {
						return true
					}
				} else {
					return true
				}
			},
			startTask(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime);
				var endTime = new Date(item.endTime);
				if(nowTime < beginTime) {
					this.$message({
						type: 'info',
						message: '作业时间未到！',
					})
					return;
				}
				if(nowTime > endTime) {
					this.$message({
						type: 'info',
						message: '作业时间已结束！',
					})
					return;
				}
				this.taskId = item.id;
				this.taskOpenIndex = true;
			},
			infoTask(item) {
				this.taskId = item.id;
				this.taskOpenInfo = true;
			},
			finiOnAppend(row) {
				this.$refs.centerfiniOnTable.toggleRowExpansion(row)
			},
			clearfiniOnFilter() {
				this.finiOnname = '';
				this.finiOntypeId = '';
				this.finiOntaskName = '';
				this.finiOnuserName = '';
				this.finiOncurrent = 1
				this.getfiniOnListData();
			},
			finiOnCurrentChange(finiOncurrent) {
				this.finiOncurrent = finiOncurrent;
				this.getfiniOnListData();
			},
			getfiniOnListData() {
				var data = {
					taskName: this.finiOntaskName ? this.finiOntaskName : null,
					username: this.finiOnuserName ? this.finiOnuserName : null,
					courseName: this.finiOnname ? this.finiOnname : null,
					courseType: this.finiOntypeId ? this.finiOntypeId : null,
					current: this.finiOncurrent,
					limit: this.limit,
				}
				listUserTaskUn(data).then(res => {
					if(res.code == "OK") {
						this.finiOnlistData = res.data.records;
						this.finiOntotal = res.data.total;
					}
				})
			},
			finiOffAppend(row) {
				this.$refs.centerfiniOffTable.toggleRowExpansion(row)
			},
			clearfiniOffFilter() {
				this.finiOffname = '';
				this.finiOfftypeId = '';
				this.finiOfftaskName = '';
				this.finiOffuserName = '';
				this.finiOffcurrent = 1
				this.getfiniOffListData();
			},
			finiOffCurrentChange(finiOffcurrent) {
				this.finiOffcurrent = finiOffcurrent;
				this.getfiniOffListData();
			},
			getfiniOffListData() {
				var data = {
					taskName: this.finiOfftaskName ? this.finiOfftaskName : null,
					username: this.finiOffuserName ? this.finiOffuserName : null,
					courseName: this.finiOffname ? this.finiOffname : null,
					courseType: this.finiOfftypeId ? this.finiOfftypeId : null,
					current: this.finiOffcurrent,
					limit: this.limit,
				}
				listUserTask(data).then(res => {
					if(res.code == "OK") {
						this.finiOfflistData = res.data.records;
						this.finiOfftotal = res.data.total;
					}
				})
			},
			getTypeList() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(res => {
					this.typeList = res.data;
				})
			},
			toCourseindex(item) {
				this.$router.push({
					name: 'coursedetail',
					query: {
						courseId: item.courseId,
						toTab:'task'
					}
				})
			},
		}
	}
</script>